import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Injector, ViewChild } from '@angular/core';
import { ViewComponent } from '../../pages/abstract/view.component';

import { HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiKey, ApiKeyService } from 'src/app/services/apikey-service';
import { ToastService } from 'src/app/services/toast.service';
import { TokenService, User } from 'src/app/services/token.service';
import { MessageDialogComponent } from '../message-dialog.component';
import { ApiKeyDisplayDialog } from './apikey-display-dialog/apikey-display-dialog';
import { ApiKeyRegistDialog } from './regist-dialog/apikey-regist-dialog';

@Component({
  selector: 'apikey-table',
  styleUrls: ['./apikey-table.component.scss'],
  templateUrl: './apikey-table.component.html',
})
export class ApiKeyTableComponent extends ViewComponent {


  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  user: User;

  displayedColumns: string[] =
    [
      'name',
      // 'apiKey',
      'restriction',
      'created',
      'action'
    ];

  constructor(
    protected override injector: Injector,
    private apiKeyService: ApiKeyService,
    public router: Router,
    public dialog: MatDialog,
    private tokenService: TokenService,
    private toastService: ToastService,
    private translate: TranslateService,
    private clipboard: Clipboard,) {
    super(injector);
  }

  ngOnInit() {
    this.user = this.tokenService.getToken().user;
    this.reload();
  }

  reload(): void {

    this.apiKeyService.list(
      new HttpParams()
        .append("sorts", "+name"))
      .subscribe({
        next: async (result) => {
          if (result.size > 0) {
            this.dataSource.data = result.data;
          } else {
            this.dataSource.data = [];
          }
        },
        error: (error) => {
          this.handlError(error);
        }
      });
  }



  ngAfterViewInit() {
    this.dataSource.sort = this.sortBpEstimate;
  }


  @ViewChild(MatSort) sortBpEstimate: MatSort;

  sortChange(sortState: Sort | null): void {
    if (!sortState || !sortState.active || !sortState.direction) {
      return;
    }
  }

  create(): void {
    this.dialog.open(ApiKeyRegistDialog, {
      data: {
      }
    })
      .afterClosed().subscribe(result => {
        if (result) {
          this.dialog.open(ApiKeyDisplayDialog, {
            data: {
              apiKey: result
            }
          });
          this.reload();
        }
      });
  }

  copyToClipboard(value: string): void {
    this.clipboard.copy(value);
    this.toastService.info(this.translate.instant('MESSAGES.COPY_SUCCESS'), '');
  }

  displayApikey(apiKey: ApiKey) {
    this.dialog.open(ApiKeyDisplayDialog, {
      data: {
        apiKey: apiKey
      }
    });
  }


  delete(data: ApiKey) {

    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '400px',
      data: {
        title: this.translate.instant('COMPONENT_TITLE.API_KEY_DELETE'),
        message: this.translate.instant('MESSAGES.CONFIRM_API_KEY_DELETE', { 'apiKeyName': data.name }),
        cancelTitle: this.translate.instant('BUTTON.CANCEL'),
        okTitle: this.translate.instant('BUTTON.DELETE'),
        onOk: () => {

          this.apiKeyService.delete(data.apiKey)
            .subscribe({
              next: (result) => {
                this.reload();
              },
              error: (error) => {
                this.handlError(error, this.form);
                console.error('Error response:', error, this.form);
              }
            });
        },
      }
    });
  }


}
